import { render, staticRenderFns } from "./AccountRegistrationForm.vue?vue&type=template&id=61d09a12&scoped=true&"
import script from "./AccountRegistrationForm.vue?vue&type=script&lang=ts&"
export * from "./AccountRegistrationForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccountRegistrationForm.vue?vue&type=style&index=0&id=61d09a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d09a12",
  null
  
)

export default component.exports